// extracted by mini-css-extract-plugin
module.exports = {"bgwrapper":"nothingList_bgwrapper__2iB_5","backgroundImage":"nothingList_backgroundImage__27_S4","tip":"nothingList_tip__1WTAY"};